/* eslint-disable array-callback-return */
/* eslint-disable indent */
import React, { useEffect, useState, useRef, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import Chart from "react-apexcharts";
import moment from "moment";

import { accessActions, userActions } from "../../../redux/actions";
import TopInput from "./TopInput";
import AttendanceList from "./AttendanceList";
import { UserTypes } from "../../../redux/type/type";
import { helperFunction } from "../../../constant/helper";
import isEmpty from "../../../validation/isEmpty";
import Card from "../../../component/card/Card";
import Starter from "../../../component/Starter";
import {
  // createdAsFunction,
  renderSheetCreatedAs,
  secondsToTime,
  totalPAH
} from "../../../constant/helper/helper";

const initialState = {
  userId: "",
  Filter: "",
  toDate: "",
  userData: {
    _id: "",
    workerId: "",
    isActive: false,
    workerSurname: "",
    workerFirstName: ""
  },
  userName: "",
  workerId: "",
  fromDate: "",
  locationId: "",
  onOffLocation: ""
};

const lineGraphState = {
  series: [
    {
      name: "",
      data: []
    }
  ],
  options: {
    chart: {
      height: 350,
      type: "line"
    },
    zoom: {
      enabled: false
    },
    colors: ["#77B6EA"],
    dataLabels: {
      enabled: true
    },
    stroke: {
      curve: "straight"
    },
    title: {
      text: "User Date vs Hours Attendance",
      align: "left"
    },
    grid: {
      // borderColor: "#e7e7e7",
      row: {
        colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
        opacity: 0.5
      }
    },
    markers: {
      size: 1
    },
    xaxis: {
      categories: [],
      title: {
        text: "Date"
      }
    },
    yaxis: {
      title: {
        text: "Daily Hours"
      }
    },
    legend: {
      position: "top",
      horizontalAlign: "right",
      floating: true,
      offsetY: -25,
      offsetX: -5
    }
  }
};

const UserWiseAttendance = () => {
  const componentRef = useRef();
  const loginType = localStorage.loginType;
  const [attendanceGraph, setAttendanceGraph] = useState(
    lineGraphState
  );
  const dispatch = useDispatch();
  const [allUsers, setAllUsers] = useState([]);
  const [values, setValues] = useState(initialState);
  const [allLocations, setAllLocations] = useState([]);
  const [userAttendanceData, setUserAttendanceData] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "onOffLocation") {
      setValues({
        ...values,
        onOffLocation: !values.onOffLocation
      });
    } else {
      setValues({
        ...values,
        [name]: value
      });
    }
  };

  const { locations } = useSelector((state) => state.location);
  const { locationId } = useSelector((state) => state.access);
  const { currentUser } = useSelector((state) => state.auth);
  const {
    toDate,
    userId,
    fromDate,
    userError,
    userLoading,
    allUserForAccess,
    userCalendarData
  } = useSelector((state) => state.user);

  useEffect(() => {
    if (userError) {
      helperFunction.toastHelper("error", userError);
    }
  }, [userError]);

  useEffect(() => {
    if (locations !== null) {
      setAllLocations(locations);
    } else {
      setAllLocations([]);
    }
  }, [locations]);

  useEffect(() => {
    if (allUserForAccess !== null) {
      setAllUsers(allUserForAccess);
    } else {
      setAllUsers([]);
    }
  }, [allUserForAccess]);

  useEffect(() => {
    setValues({
      ...values,
      locationId,
      fromDate,
      toDate,
      userId
    });
  }, [locationId, fromDate, toDate, userId]);

  useEffect(() => {
    if (typeof userCalendarData === "undefined") {
      setUserAttendanceData({});
    } else if (
      !isEmpty(userCalendarData) &&
      !isEmpty(userCalendarData.attendances)
    ) {
      const lineData = [];
      const lineLabel = [];
      const dailyPoints = [];

      userCalendarData.attendances.map((attendanceObject) => {
        let createdAs;
        let duration;
        let shiftCode;
        let inTime;
        let outTime;
        let inLocation;
        let outLocation;

        if (isEmpty(attendanceObject)) {
          createdAs = "-";
          duration = 0;
          shiftCode = "-";
          inTime = "-";
          outTime = "-";
          inLocation = "-";
          outLocation = "-";
        } else {
          createdAs = renderSheetCreatedAs(attendanceObject);
          duration = attendanceObject.duration;
          shiftCode = attendanceObject.shiftCode;
          inTime = attendanceObject.inTime;
          outTime = attendanceObject.outTime;
          inLocation = attendanceObject.inLocation;
          outLocation = attendanceObject.outLocation;
        }
        const parts = attendanceObject.date.split("/"); // Split the string by "/"
        const day = parts[0];
        const month = parts[1];
        const year = parts[2];

        // Construct the new date string in "year/month/day" format
        const newDateString = `${year}-${month}-${day}`;
        lineData.push(attendanceObject.duration);
        lineLabel.push(moment(newDateString).format("D MMM"));

        return dailyPoints.push({
          Date: attendanceObject.date,
          shiftCode,
          createdAs,
          inTime,
          outTime,
          inLocation,
          outLocation,
          duration,
          locationName: userCalendarData.locationName
        });
      });
      const {
        TotalHours,
        TotalPl,
        TotalNbl,
        TotalPtl,
        TotalMtl,
        TotalBl,
        TotalCo,
        TotalOh,
        TotalPh,
        TotalOd,
        TotalEo,
        TotalLc,
        TotalHd,
        TotalOT,
        TotalAml,
        TotalWop,
        TotalPresent,
        TotalAbsent,
        TotalWeekOf
      } = totalPAH(dailyPoints);
      setUserAttendanceData({
        TotalPl,
        TotalNbl,
        TotalPtl,
        TotalMtl,
        TotalBl,
        TotalCo,
        TotalOh,
        TotalPh,
        TotalOd,
        TotalEo,
        TotalLc,
        TotalHd,
        TotalOT,
        TotalAml,
        TotalWop,
        TotalPresent,
        TotalAbsent,
        TotalWeekOf,
        dailyPointsArray: dailyPoints,
        workerFullName:
          userCalendarData.workerFirstName +
          " " +
          userCalendarData.workerSurname,
        workerId: userCalendarData.workerId,
        total_duration: secondsToTime(TotalHours),
        totalDays: !isEmpty(dailyPoints) ? dailyPoints.length : 0
      });

      setAttendanceGraph({
        ...attendanceGraph,
        options: {
          xaxis: {
            categories: lineLabel
          }
        },
        series: [
          {
            name: "User Date vs Hours Graph",
            data: lineData
          }
        ]
      });
    } else {
      setUserAttendanceData({});
    }
  }, [userCalendarData]);

  // on location change
  const onLocationChange = (e) => {
    e.preventDefault();
    const { value } = e.target;
    setValues({
      ...values,
      locationId: value
    });
    dispatch(accessActions.getAllUsersForAccess(loginType, value));
  };

  // on user name select
  const onUserSelect = (e) => {
    const { value } = e.target;
    allUsers.find((accessUserData, i) => {
      if (accessUserData._id === value) {
        const workerFullName =
          accessUserData.workerFirstName +
          " " +
          accessUserData.workerSurname;
        setValues({
          ...values,
          userName: workerFullName,
          workerId: accessUserData.workerId,
          userData: accessUserData,
          userId: value
        });
      }
    });
  };

  const commonDispatch = () => {
    dispatch(userActions.setUserLoading(true));
    dispatch(userActions.clearUserErrors());
    dispatch(userActions.clearUserResult());
  };

  const onSubmit = () => {
    if (
      values.fromDate === "" ||
      values.toDate === "" ||
      values.userId === ""
    ) {
      const errorData = {
        data: {
          message: "From Date,To Date or User is not selected"
        },
        status: 400
      };
      return dispatch({
        type: UserTypes.USER_GET_ERRORS,
        payload: errorData
      });
    } else {
      const dateRange = {
        fromDate: values.fromDate,
        toDate: values.toDate
      };
      const user_id = values.userId;
      commonDispatch();
      dispatch(
        userActions.getUserCalendarData(user_id, dateRange, loginType)
      );
    }
  };

  return (
    <Starter
      topBarTitle="User Custom Attendance"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Attendance Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Attendance</a>
          </li>
          <li className="breadcrumb-item active">
            User Custom Attendance
          </li>
        </Fragment>
      }
    >
      <TopInput
        values={values}
        allUsers={allUsers}
        onSubmit={onSubmit}
        loginType={loginType}
        userLoading={userLoading}
        currentUser={currentUser}
        allLocations={allLocations}
        onUserSelect={onUserSelect}
        onLocationChange={onLocationChange}
        handleInputChange={handleInputChange}
      />
      <div className="row">
        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
          <AttendanceList
            values={values}
            userLoading={userLoading}
            componentRef={componentRef}
            userAttendanceData={userAttendanceData}
          />
        </div>
        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
          <Card>
            <Chart
              options={attendanceGraph.options}
              series={attendanceGraph.series}
              type="line"
              height={450}
            />
          </Card>
        </div>
      </div>
    </Starter>
  );
};

export default UserWiseAttendance;
